import _ from 'underscore';
import Promise from 'bluebird';
import { Decorator } from './decorator';

export class ChartDataParametersDecorator extends Decorator {
  /**
   * Creates an instance of ChartDataParametersDecorator.
   * @param {Object} options options
   * @param {Object} options.entitySet entitySet
   * @param {Object} options.pageContext pageContext
   * @param {Object} options.chartDataAdapter chartDataAdapter
   * @param {Object} options.inlineChartPreference inlineChartPreference
   * @memberof ChartDataParametersDecorator
   */
  constructor({
    entitySet,
    pageState,
    pageContext,
    chartDataAdapter,
    inlineChartPreference,
    isOdataActionSource,
  }) {
    super({ name: 'chartDataParameters' });

    this.entitySet = entitySet;
    this.pageState = pageState;
    this.pageContext = pageContext;
    this.chartDataAdapter = chartDataAdapter;
    this.inlineChartPreference = inlineChartPreference;
    this.isOdataActionSource = isOdataActionSource;
  }

  getValueAsync() {
    return Promise.all([
      this.pageState.getPromise('$daterange'),
      this.chartDataAdapter.getPreferencesAndDefaults(
        this.inlineChartPreference,
        this.pageContext
      ),
    ]);
  }

  buildQuery(queryParams, [dateRange, chartParams]) {
    if (!this.isOdataActionSource) {
      return queryParams;
    }
    const transformedQueryParams = _.extend({}, queryParams);
    const params = {
      ...(transformedQueryParams.bodyParameters || {}),
      performanceTimeSeriesParameters:
        this.chartDataAdapter.formatPreferenceValue(dateRange, chartParams),
    };

    transformedQueryParams.options = _.extend({}, queryParams.options || {}, {
      entitySet: this.entitySet
        .$call(params),
    });

    transformedQueryParams.bodyParameters = params;
    return transformedQueryParams;
  }
}
